var app = angular.module("leonardo");

var WorkFlowInstanceListFilters = function (
  $scope,
  $state,
  WorkFlowInstanceService,
  $controller,
  WorkFlowService
) {

  $controller('FiltersBaseController', { $scope: $scope });
  
  if (!$scope.filterService.hasFilter('property_reports') && $scope.filterService.currentProperty) {
    $scope.filterService.setFilter('property_reports', $scope.filterService.currentProperty.id, true);
  }

  $scope.by_unit = $state.current.by_unit;

  $scope.filters_options = [
    {
      group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1,
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        },
        {
          id: 'managed_by_reports',
          name: 'Management Company',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Management Companies',
          condition: $scope.filterService.managers.length > 1,
          options: $scope.filterService.managers,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'account_reports']
        },
        {
          id: 'group_reports',
          name: 'Property Group',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Groups',
          condition: $scope.filterService.groups.length > 1 && !$scope.only_account,
          options: $scope.filterService.groups,
          conflicts: ['property_reports', 'portfolio_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'portfolio_reports',
          name: 'Portfolio',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Portfolios',
          condition: $scope.filterService.portfolios.length > 1 && !$scope.only_account,
          options: $scope.filterService.portfolios,
          conflicts: ['property_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        },
        {
          id: 'property_reports',
          name: 'Property',
          label: null,
          inline: false,
          type: 'property_selector',
          multiple: true,
          placeholder: 'All Properties',
          condition: $scope.filterService.properties.length > 1 && !$scope.only_account,
          options: $scope.filterService.properties,
          conflicts: ['portfolio_reports', 'group_reports', 'managed_by_reports', 'account_reports']
        }
      ]
    },
    {
      id: 'status',
      name: 'Status',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Status',
      condition: true,
      options: WorkFlowInstanceService.STATUS_OPTIONS,
      conflicts: []
    },
    {
      id: 'search',
      name: $scope.by_unit ? 'Unit workflow name' : 'Workflow name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: $scope.by_unit ? 'Unit workflow name' : 'Workflow name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    },
    {
      id: 'started_from_date',
      name: 'Launched Date From',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Launched Date From',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      positionVertical: 'bottom',
      endDate: 'started_to_date'
    },
    {
      id: 'started_to_date',
      name: 'Launched Date To',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Launched Date To',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      startDate: 'started_from_date',
      dateNoFuture: true,
      positionVertical: 'bottom'
    },
    {
      id: 'date_range_started',
      name: 'Launched Date Range',
      label: null,
      inline: false,
      type: 'date_range',
      placeholder: 'Launched Date Range',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      startDate: 'started_from_date',
      endDate: 'started_to_date'
    },
    {
      id: 'completed_from_date',
      name: 'Completed Date From',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Completed Date From',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      positionVertical: 'bottom',
      endDate: 'completed_to_date'
    },
    {
      id: 'completed_to_date',
      name: 'Completed Date To',
      label: null,
      inline: false,
      type: 'date',
      placeholder: 'Completed Date To',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      startDate: 'completed_from_date',
      dateNoFuture: true,
      positionVertical: 'bottom'
    },
    {
      id: 'date_range_completed',
      name: 'Completed Date Range',
      label: null,
      inline: false,
      type: 'date_range',
      placeholder: 'Completed Date Range',
      condition: !!$state.current.workflows_in_progress,
      conflicts: [],
      startDate: 'completed_from_date',
      endDate: 'completed_to_date'
    }
  ];

  if ($scope.by_unit) {
    $scope.filters_options = [
      ...$scope.filters_options,
      {
        id: 'is_unit_turn',
        name: 'Unit Turn',
        label: null,
        inline: false,
        type: 'options',
        multiple: false,
        placeholder: 'Unit Turn',
        condition: true,
        options: WorkFlowService.IS_UNIT_TURN_OPTIONS,
        conflicts: []
      },
      {
        id: 'unit_turn_type',
        name: 'Unit Turn Type',
        label: null,
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Unit Turn Type',
        condition: true,
        options: WorkFlowService.UNIT_TURN_WORKFLOW_OPTIONS,
        conflicts: []
      }
    ]
  }

  $scope.filterService.showFilters(['property_reports', 'status', 'search', 'date_range_started', 'started_from_date', 'started_to_date']);

};

app.controller('WorkFlowInstanceListFilters', [
  '$scope',
  '$state',
  'WorkFlowInstanceService',
  '$controller',
  'WorkFlowService',
  WorkFlowInstanceListFilters
]);
